import { type AlertProps, Alert as AntdAlert } from 'antd';
import { type ElementRef, forwardRef } from 'react';

export const Alert = forwardRef<ElementRef<typeof AntdAlert>, AlertProps>(
  (props, ref) => {
    if (!props.message) {
      return null;
    }
    if (typeof props.message === 'string' && props.message.trim() === '') {
      return null;
    }
    return <AntdAlert ref={ref} {...props} data-dd-privacy="allow" />;
  },
);

Alert.displayName = 'Alert';
